import { HTMLAttributes } from "react"

import { Translate } from "../translate"
import { BaseTypographyProps } from "./types"

/* -------------------------------------------------------------------------------------------------
 * types
 * -----------------------------------------------------------------------------------------------*/

type H4Props = BaseTypographyProps & HTMLAttributes<HTMLHeadingElement>

/* -------------------------------------------------------------------------------------------------
 * component
 * -----------------------------------------------------------------------------------------------*/

const H4 = ({ i18nKey, values, formats, ...props }: H4Props) => {
  return (
    <h1 {...props}>
      <Translate i18nKey={i18nKey} values={values} formats={formats} />
    </h1>
  )
}

export { H4 }
